"use client";

// app/global-error.tsx
// Required by Next.js — replaces the built-in /_global-error page.
// Must be "use client". Renders outside the root layout, so no auth/DB calls.

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body style={{ fontFamily: "sans-serif", background: "#0f0520", color: "white", display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", margin: 0 }}>
        <div style={{ textAlign: "center", padding: "2rem" }}>
          <div style={{ fontSize: "4rem", marginBottom: "1rem" }}>⚠️</div>
          <h1 style={{ color: "#a78bfa", fontSize: "1.5rem", fontWeight: 900, marginBottom: "0.5rem" }}>
            Something went wrong
          </h1>
          <p style={{ color: "#7c3aed", marginBottom: "1.5rem", fontSize: "0.875rem" }}>
            {error.digest ? `Error ID: ${error.digest}` : "An unexpected error occurred."}
          </p>
          <button
            onClick={reset}
            style={{ background: "#7c3aed", color: "white", border: "none", borderRadius: "0.75rem", padding: "0.75rem 1.5rem", fontWeight: 700, cursor: "pointer", fontSize: "1rem" }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
